import { CalculatorContext } from "App";
import { useState, useEffect, useContext } from "react";

export const ValuationModal = ({ isOpen, handleClose, handleValuation }) => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [errors, setErrors] = useState<Record<string, string>>({
    name: "",
    surname: "",
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "", // Reset the error message when the input changes
    });
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = {} as Record<string, string>;

    // Name Validation
    if (formData.name.length > 100 || formData.name.length < 1) {
      valid = false;
      newErrors.name = "Imię musi zawierać od 1 do 100 znaków";
    }

    // Surname Validation
    if (formData.surname.length > 100 || formData.surname.length < 1) {
      valid = false;
      newErrors.surname = "Nazwisko musi zawierać od 1 do 100 znaków";
    }

    // Email Validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      valid = false;
      newErrors.email = "Nieprawidłowy adres e-mail";
    }

    // Phone Validation
    if (formData.phone.length > 100 || formData.phone.length < 1) {
      valid = false;
      newErrors.phone = "Telefon Nazwisko musi zawierać od 1 do 100 znaków";
    }

    setErrors(newErrors);

    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      handleValuation(formData);
      setIsSubmitted(true);
    }
  };

  const handleClickCloseButton = () => {
    handleClose();
    setIsSubmitted(false);
    setFormData({
      name: "",
      surname: "",
      email: "",
      phone: "",
    });
  };

  useEffect(() => {
    setErrors({
      name: "",
      surname: "",
      email: "",
      phone: "",
    });
  }, [formData]);

  const context = useContext(CalculatorContext);

  const { translations } = context!;

  return (
    isOpen && (
      <div className="fixed-modal">
        <div className="box-modal">
          <div className="modal-content">
            <div className="close-modal">
              <button onClick={handleClickCloseButton}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>
            <form onSubmit={handleSubmit} className="form-valuation">
              {isSubmitted ? (
                `${translations["sended-to-evaluate"]}`
              ) : (
                <>
                  <h2>{translations["data-for-valuation"]}</h2>
                  <label>
                    {translations["form-name"]}:
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && (
                      <span className="error">{errors.name}</span>
                    )}
                  </label>
                  <label>
                    {translations["form-surname"]}:
                    <input
                      type="text"
                      name="surname"
                      autoComplete="family-name"
                      value={formData.surname}
                      onChange={handleChange}
                    />
                    {errors.surname && (
                      <span className="error">{errors.surname}</span>
                    )}
                  </label>
                  <label>
                    {translations["form-email"]}:
                    <input
                      type="email"
                      name="email"
                      autoComplete="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    {errors.email && (
                      <span className="error">{errors.email}</span>
                    )}
                  </label>
                  <label>
                    {translations["form-phone"]}:
                    <input
                      type="tel"
                      name="phone"
                      id="phone"
                      autoComplete="tel"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    {errors.phone && (
                      <span className="error">{errors.phone}</span>
                    )}
                  </label>
                  <button
                    type="submit"
                    className="btn-send"
                    style={{ marginTop: "1rem" }}
                  >
                    {translations["form-send"]}
                  </button>
                </>
              )}
            </form>
          </div>
        </div>
      </div>
    )
  );
};
